const fr = {
  general: {
    position: 'Fonction',
    updateSuccess: 'Actualisation réussie !',
    editProfileImg: 'Image de profil',
    editCoverImg: 'Photo de couverture',
    register: 'S\'inscrire',
    login: 'Connexion',
    date: 'Date',
    export: 'export',
    or: 'ou',
    end: 'Finir',
    confirmEmail: 'Confirmez votre email',
    password: 'Mot de passe',
    forgetPassword: 'Vous avez oublié votre mot de passe ?',
    changePassword: 'Changer votre mot de passe',
    confirmPassword: 'Confirmez votre nouveau mot de passe',
    knownAs: 'Surnom',
    oldPassword: 'Ancien mot de passe',
    newPassword: 'Nouveau mot de passe ',
    minLength: 'La longueur minimale est de {n}',
    unmatched: '{col} ne correspond pas.',
    chooseAnotherAccount: 'Connectez-vous avec un autre compte',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    required: 'Champs requis.',
    country: 'Pays',
    new: 'NOUVEAU',
    username: 'Nom d\'utilisateur',
    category: 'Catégorie'
  },
  editPhoto: 'Modifier photo',
  deletePhoto: 'Supprimer la photo',
  changePhoto: 'Changer la photo',
  savePhoto: 'Enregistrer la photo',
  livetour: 'Salle d\'exposition',
  country: {
    JP: 'Japon',
    KR: 'Corée',
    HK: 'Hong Kong et Macao',
    SG: 'Singapour',
    MY: 'Malaisie',
    TH: 'Thaïlande',
    VN: 'Viêt Nam',
    ID: 'Indonésie',
    PH: 'Philippines',
    EU: 'Europe',
    NA: 'Amérique du Nord',
    NZ: 'Nouvelle-Zélande et Australie',
    TW: 'Taïwan'
  },
  vrlounge: {
    lounge: 'VR Lounge',
    networking: 'Networking',
    profile: 'Mon profil',
    peopleOnline: 'Personnes en ligne',
    totalVisitors: 'Total de visiteurs',
    connect: 'Connecter',
    waitConfirmed: 'Attendre la confirmation',
    isConfirmed: 'confirmé',
    confirm: 'confirmer',
    reject: 'rejeter',
    confirmReject: 'Êtes-vous certain de rejeter ?',
    hintReject: 'Annulation impossible',
    thinkTwice: 'Laisse-moi réfléchir à deux fois',
    rejectInvitation: 'Refuser l\'invitation',
    connectSuccess: 'Rencontrez le succès !',
    block: 'bloquer',
    visitor: 'Visiteur',
    exhibitor: 'Exposant',
    invitationTitle: 'Message d\'invitation personnalisé',
    invitationPlaceholder: 'Bonjour ! Au plaisir de communiquer avec vous ! (maximum 1000 caractères)',
    noTicketRecord: 'Aucun enregistrement de ticket. Veuillez acheter un ticket.',
    invalidTicket: 'Ticket invalide',
    enterTicket: 'Veuillez saisir votre numéro de ticket',
    sent: 'Envoyé',
    received: 'Reçu',
    connected: 'Connecté',
    agreeToContinue: 'Vous devez accepter les conditions générales et la politique de confidentialité pour continuer.',
    ticketUsed: 'Ce ticket a été utilisé.',
    passwordRule: 'Le mot de passe doit contenir 8 caractères, au moins une lettre et un chiffre.',
    cardExchange: 'Le visiteur souhaite échanger des cartes de visite avec vous, veuillez accepter ou refuser l\'échange.',
    loginToAccount: 'Connectez-vous à votre compte',
    keepLogin: 'Rester connecté',
    cantLogin: 'Vous ne parvenez pas à vous connecter ? Cliquez sur',
    here: 'ici',
    allRole: 'tous les rôles',
    sortNameAtoZ: 'Nom (A→Z)',
    sortNameZtoA: 'Nom (Z→A)',
    onlineNewToOld: 'Heure de la dernière connexion (dernière)',
    onlineOldToNew: 'Heure de la dernière connexion (la plus ancienne)',
    exhibitorFirst: 'Exposant d\'abord',
    visitorFirst: 'Visiteur d\'abord',
    inviteTimeNewToOld: 'Heure d\'invitation (dernière)',
    inviteTimeOldToNew: 'Heure d\'invitation (au plus tôt)',
    basicInfo: 'Informations de base',
    contact: 'Contact',
    contactInfo: 'coordonnées',
    state: 'État',
    sentRequest: 'envoyer une demande',
    haveNotConfirmed: 'vous n\'avez pas encore confirmé',
    message: 'Un message',
    sendMessageTo: 'Envoyer un message à'
  },
  sort: 'Sorte',
  filter: 'Filtre',
  test: 'Tester',
  apply: 'Appliquer',
  all: 'Tout',
  livingroom: 'Salon',
  diningroom: 'Salle à manger',
  kitchen: 'Cuisine',
  bedroom: 'Chambre',
  study: 'Bureau',
  bathroom: 'Salle de bain',
  toilet: 'Toilettes',
  garden: 'Jardin',
  garage: 'Garage',
  outdoors: 'Extérieur',
  others: 'Autre',
  vrTooltip: 'Le mode VR n\'est accessible qu\'à partir d\'un smartphone',
  vrInstructions: 'Veuillez insérer votre <strong>mobile</strong> dans un <strong>casque VR </strong>.',
  send: 'Envoyer',
  scanQrCode: 'Scannez le QR code pour visualiser le LiveTour sur votre smartphone.',
  logOut: 'Déconnection',
  postAsAnonymous: 'Non merci, je posterai en tant qu\'anonyme.',
  loginGoogle: 'Se connecter avec Google+',
  loginFacebook: 'Se connecter avec Facebook',
  postComment: 'Laisser un commentaire',
  selectAction: 'Choisissez s\'il vous plaît',
  noBuilding: 'Désolé, ce LiveTour n\'existe pas.',
  browserNoSupport: '<h3>Désolé votre navigateur n\'est pas pris en charge</h3><p>Veuillez télécharger un navigateur plus récent, par exemple <a href="https://www.google.com/chrome/browser/desktop">Chrome</a>,<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a>, ou<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>.</p>',
  webGlNoSupport: '<h3>Echec de la requète WEBGL. Votre navigateur ou votre device peut ne pas supporter WebGL.</h3>',
  urlNoSupportIFrameError: 'Ce lien a expiré, ou bien la page n\'accepte pas de liens externes sous forme d\'embed.',
  noPanoramas: 'Oups ! Le panorama n\'existe pas.',
  buildingNotFound: '<h3>Le lien n\'existe pas </h3><p> Le LiveTour ne peut pas être trouvé</p><a href="https://www.istaging.com/fr/livetour-gallery">Voir d\'autres LiveTours</a>',
  buildingNotInPropertyRedirect: '<h3>Oops ! Ce LiveTour a été supprimé.</h3><p>Nous vous dirigeons vers le premier LiveTour de la liste...</p>',
  information: 'Information',
  panoSelect: 'Panoramas',
  floorplan: 'Plan au sol',
  qrCode: 'QR Code',
  music: 'Musique',
  openMusic: 'Activer la musique de fond',
  closeMusic: 'désactiver la musique de fond',
  gyro: 'Gyroscope',
  vrmode: 'Mode VR',
  fullscreen: 'Plein écran',
  like: 'J\'aime',
  comment: 'Commentaire',
  propertyInfo: 'Info du groupe',
  buildingInfo: 'Info du LiveTour',
  buyNow: 'Acheter maintenant',
  viewAtHome: 'Visualiser en AR',
  learnMore: 'En savoir davantage',
  contactSupplier: 'Contacter le fournisseur',
  memo: 'Mémo',
  location: 'Localisation',
  promotionText: 'Créez votre LiveTour maintenant à',
  promotionLinkText: 'istaging.com',
  close: 'Fermer',
  addComment: 'Ajouter un commentaire',
  share: 'Partager',
  leaveInfoContinue: 'Dites-nous qui vous êtes afin de visiter ce LiveTour',
  company: 'Entreprise',
  companyName: 'Nom de l\'entreprise',
  name: 'Prénom',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  email: 'Email',
  phone: 'Téléphone',
  emailFormatInvalid: 'Format d\'email invalide',
  duplicateEmail: 'E-mail en double',
  privacyPolicy: 'Politique de confidentialié',
  userTerms: 'Conditions générales d\'utilisation',
  visitorLogin: 'Avez-vous déjà un compte ?',
  visitorAgreement: 'J\'accepte les <a href="https://www.istaging.com/legal/terms_of_service" target="_blank">conditions générales d\'utilisation </a> et <a href="https://www.istaging.com/legal/privacy_policy" target="_blank">la politique de confidentialité</a> iStaging',
  visitorLeaveDataReason: 'Bienvenue dans cette expérience virtuelle ! Une fois que vous aurez soumis vos informations de contact, vous recevrez un lien de vérification par e-mail, afin que vous puissiez entrer.',
  visitorAgreePolicy: 'J\'accepte que le propriétaire du LiveTour puisse me contacter par mail ou téléphone.',
  visitorCheckTheEmail: 'Vous y êtes presque !<br>Veuillez confirmer votre adresse mail. Veuillez accéder à votre messagerie et cliquer sur le lien reçu.<br>Vous êtes sur le point d\'accéder à la visite !',
  visitorEnterAccessKey: 'Veuillez entrer le code d\'accès que vous avez reçu par email. Vérifiez votre dossier spam si vous ne l\'avez pas reçu.',
  accessCode: 'Code d\'accès',
  accessCodeError: 'Erreur de code d\'accès',
  receiveEmailVerification: 'Veuillez récupérer votre code d\'accès dans votre e-mail.',
  verify: 'Vérifier',
  back: 'Précédent',
  welcomeToLiveTour: 'Bienvenue sur le <strong>LiveTour</strong>',
  resend: 'Renvoyer',
  invalidAccessCode: 'Le code d\'accès est invalide',
  resendCodeError: 'Echec au renvoi du code d’accès',
  website: 'Site web',
  cardMore: 'Davantage',
  clickNavigate: 'Naviguer',
  showMore: 'En voir davantage',
  searchTag: 'Tag Recherche',
  somethingWrong: '<h3>Vous rencontrez un souci de visualisation sur ce navigateur.</h3><p>Copiez l\'URL de la page et collez-la dans Google Chrome, Firefox ou Safari.</p><a href="https://www.istaging.com/fr/contact">signaler ce problème inconnu</a>',
  GuidedTour: 'Visite guidée',
  ClientWelcome: 'Bienvenue',
  ClientFormHint: 'En cliquant sur  « Appelez maintenant » , vous acceptez les <a href="https://www.istaging.com/legal/terms_of_service" target="_blank" class="link-yellow">conditions générales d’utilisation</a> et <a class="link-yellow" href="https://www.istaging.com/legal/privacy_policy" target="_blank">termes de confidentialité </a> et l’agent peut vous contacter par téléphone.',
  ClientFormWelcomeText: 'Remplissez les informations suivantes et cliquez sur Appelez maintenant. <br>Vous serez guidé en ligne par un agent. <br>Connectez votre casque et votre microphone et assurez-vous d\'avoir une bonne connexion réseau pour une meilleure expérience.',
  ClientWelcomeNamePhoneHint: 'Veuillez entrer votre nom et votre numéro de téléphone',
  ClientWelcomeNameHint: 'Veuillez entrer votre nom',
  ClientWelcomePhoneHint: 'Veuillez entrer le numéro de téléphone ou le format est incorrect',
  ClientWelcomeLanguage: 'Langue',
  ClientWelcomeLanguageDesc: 'Veuillez sélectionner la langue de votre guide :',
  ClientWelcomeLanguageHint: 'Veuillez sélectionner une langue',
  FieldRequired: '* Requis',
  ClientFormCallNow: 'Appelez maintenant',
  None: 'Non disponible',
  Agent: 'Agent',
  RememberMe: 'Se souvenir de moi',
  TheFieldIsRequired: '*champs requis',
  IncorrectFormat: 'Mauvais format',
  YouMustAgreeLicense: 'Vous devez accepter les termes mentionnés ci-dessus.',
  Submit: 'Soumettre',
  BuildingNonPublicInfo: 'Ce LiveTour est dépublié.',
  WebRTCNotSupportTitle: 'Navigateur non pris en charge',
  WebRTCNotSupportDesc: 'Copiez l\'URL de la page et collez dans le navigateur Google Chrome/Firefox ou Safari',
  WebRTCNotSupportDesciOS: 'Copiez l\'URL de la page et coller dans Safari',
  WebRTCNotSupportDescAndroid: 'Copier l\'URL de la page et coller dans Chrome ou Firefox',
  WebRTCNotSupportCopyButton: 'Copie en un clic',
  Copied: 'Copie complète',
  search: 'Chercher',
  searchContent: 'Rechercher du contenu',
  noResult: 'Aucun résultat',
  searchResult: 'Résultat de la recherche',
  relatedResult: 'Résultat associé',
  scaleUp: 'Agrandir',
  scaleDown: 'Réduire',
  viewIn3D: 'Voir en 3D',
  unableJoinMeeting: 'Impossible de rejoindre la réunion',
  invalidMeetingId: 'Salle de réunion invalide',
  unableAccessMediaDevice: 'Votre navigateur empêche l\'accès à votre caméra / microphone, veuillez vérifier les paramètres d\'autorisation de votre navigateur.',
  connectingMeeting: 'Vous allez organiser une réunion',
  meetingNotStartedYet: 'Impossible de rejoindre la salle, la réunion n\'a pas encore commencé.',
  joinedMeeting: 'Vous êtes en réunion',
  joiningMeeting: 'Vous allez rejoindre une réunion',
  repeatJoinWarning: 'Si vous rejoingnez de nouveau, la page connectée à l\'origine sera déconnectée.',
  meetingIsOver: 'La réunion est terminée.',
  startAnotherMeeting: 'Veuillez vous rendre à l\'éditeur pour démarrer une autre réunion.',
  closeMeeting: 'Fermer',
  joinMeeting: 'Rejoindre la réunion',
  leaveMeeting: 'Quitter',
  remainTime: 'Temps restant',
  meetingIsFull: 'Votre salle de réunion est complète',
  connectionFail: 'Connexion perdue',
  unableConnectMeeting: 'Impossible de rejoindre la réunion',
  joinMeetingFail: 'Échec de participation à la réunion',
  aboutEndMeeting: 'Vous êtes sur le point de mettre fin à cette réunion',
  aboutLeaveMeeting: 'Vous êtes sur le point de quitter cette réunion',
  endedMeeting: 'Cette réunion est terminée',
  meetingRedirect: 'Nous vous dirigeons vers le LiveTour',
  leftMeeting: 'Vous avez quitté la réunion',
  waitMeeting: 'L\'hôte quitte temporairement et la réunion se poursuivra après la connexion de l\'hôte. Si vous n\'êtes pas connecté dans les 5 minutes, la réunion se terminera.',
  disconnectMeeting: 'Vous êtes déconnecté. Veuillez essayer de vous reconnecter dans les 5 minutes et actualisez la page pour revenir à la réunion.',
  copyLink: 'Copier le lien',
  copySuccess: 'Copié avec succès',
  confirm: 'OK',
  cancel: 'Annuler',
  IMServe: 'Service client instantané',
  product: 'Produit',
  pilot: 'Pilote',
  pilotBooking: 'réserver une visite',
  pilotStop: 'Arrêter le pilotage',
  pilotTours: 'Tours',
  pilotPopularTours: 'Tours populaires',
  pilotInfluencerList: 'Liste des guides touristiques',
  pilotTourBy: 'Visite par {influencer}',
  PilotDescription: 'Description',
  PilotDetailedInformation: 'Des informations détaillées',
  pilotSwitchTourNotice: 'Vous enregistrez dès à présent "{pilot1}".<br>Voulez-vous vraiment démarrer "{pilot2}"?',
  pilotSameTourNotice: 'Vous enregistrez dès à présent "{pilot1}".<br>Voulez-vous repartir du début ?',
  pilotPlayerPopupButtonYes: 'Oui',
  pilotRecorderStart: 'Cliquez ici pour commencer',
  pilotRecorderStop: 'Cliquez ici pour arrêter',
  pilotRecorderUploading: 'Téléchargement en cours',
  pilotRecorderUploadFailed: 'Le téléchargement a échoué',
  pilotRecorderPopupTitleNotice: 'Précautions',
  pilotRecorderPopupTitleComplete: 'Enregistrement terminé',
  pilotRecorderPopupTitleError: 'Erreur',
  pilotRecorderPopupTextNotice: '• La durée d\'enregistrement est limitée à 10 minutes. <br> • Veuillez d\'abord autoriser le système à accéder au microphone.',
  pilotRecorderPopupTextComplete: 'L\'enregistrement de votre chapitre est terminé. Veuillez vérifier dans VR Editor.',
  pilotRecorderPopupTextRelogin: 'Veuillez vous reconnecter',
  pilotRecorderPopupTextError: 'Votre navigateur empêche l\'accès à votre microphone, veuillez vérifier les paramètres d\'autorisation multimédia du navigateur.',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: 'Attention, la durée d\'enregistrement de 10 minutes va se terminer très bientôt.',
  pilotTooltipTitle: 'Rappel, vous pouvez cliquer ici pour voir plus d\'itinéraires guidés. ',
  pilotTooltipConfirm: 'Je vois ! commençons',
  pilotTooltipCancel: 'Ignorer la visite',
  selectPilot: 'Sélectionner un pilote',
  pilotInfluencer: 'Pilote influenceur',
  pilotChaptersTitle: 'Acheminer les chapitres (choisir d\'écouter)',
  pilotReadMoreBtnLabel: 'Afficher le contenu complet',
  pilotSelfBrowsingModeMessageTitle: 'Entrer en mode d\'auto-navigation',
  pilotSelfBrowsingModeMessageContent: 'Vous pouvez revenir en mode visite à tout moment en cliquant sur le bouton d\'activation.',
  pilotReplay: 'Rejouer',
  pilotPrevious: 'Précédent',
  pilotNext: 'Suivant',
  pilotPause: 'Pause',
  pilotPlay: 'Jouer',
  pilotTurnOnSelfBrowsingMode: 'Désactiver le mode visite',
  pilotTurnOffSelfBrowsingMode: 'Activer le mode visite',
  uploadImage: 'Télécharger une image',
  productUnavailable: 'Ce produit n\'est plus disponible',
  booking: {
    calendar: 'Calendrier',
    reserve: 'Réserver',
    dateSelectTitle: 'Choisissez un moment qui vous convient.',
    backToSelect: 'Choisissez une autre heure',
    requiredField: 'Ceci est un champ obligatoire',
    timeRange: 'Intervalle de temps',
    fieldMessage: 'Message',
    confirm: 'Confirmer la réservation',
    pleaseWait: 'Veuillez patienter...',
    submitError: 'Une erreur s\'est produite lors de l\'envoi de la demande: ',
    reserveSuccess: 'Rendez-vous réussi',
    thanksUser: 'Merci,',
    confirmingEmail: 'Vous recevrez sous peu une notification confirmant les détails de la réunion.',
    emailEmptyHint: 'L\'e-mail est vide.'
  },
  favorites: {
    title: 'Favoris',
    add: 'Ajouter aux favoris',
    remove: 'Supprimer des favoris',
    category: {
      marker: 'Produit',
      panorama: 'Showroom',
      company: 'Entreprise',
      card: 'Entreprise'
    },
    table: {
      image: {
        company: 'Logo',
        marker: 'Image produit',
        card: 'Avatar'
      },
      name: {
        company: 'Nom de l\'entreprise',
        marker: 'Nom du produit',
        card: 'Prénom'
      },
      description: {
        company: 'Description de l\'entreprise',
        marker: 'Description du produit'
      },
      type: 'Type',
      // price: 'Price',
      note: 'Note',
      company: 'Entreprise',
      occupation: 'Occupation',
      listEmpty: 'Rien pour le moment'
    },
    note: {
      empty: 'Insérer des notes (jusqu\'à {n} lettres)',
      saved: 'Sauvegardé !'
    },
    pdf: {
      export: 'Export en PDF',
      exporting: 'Export en cours',
      note: 'Note: ',
      pager: 'Page {page} sur {total}'
    }
  },
  video360: {
    notAvailable: 'The video is not available in your country.'
  },
  utils: {
    more: 'Show More',
    less: 'Show Less'
  },
  popup: {
    soundOn: 'Activer le son',
    soundOff: 'Désactiver le son'
  },
  introAssets: {
    enter: 'Entrer'
  },
  whiteList: {
    login: 'Connectez-vous pour explorer!',
    error: '* Compte ou mot de passe invalide! Veuillez réessayer.',
    warnTitle: 'Authentification échouée',
    warnContent: 'Votre nom d\'utilisateur n\'existe pas dans la liste autorisée, veuillez réessayer ou contacter l\'administrateur.'
  },
  instantMessaging: {
    quickQA: 'Questions & Réponses',
    mediaMessage: 'Fichier partagé',
    locationMessage: 'Fichier partagé',
    startConversation: 'Entamez une conversation avec l\'organisateur dans cet espace d\'exposition !'
  },
  noSearchResult: 'Aucune donnée n\'est trouvée, veuillez modifier les conditions de la requête et relancer la recherche',
  tourring: {
    host: 'Hôte',
    noAnswer: 'Votre contact n’est actuellement incapable de répondre.',
    noPushId: 'Votre contact n’est actuellement pas disponible.',
    busy: 'Votre contact n’est actuellement occupé.',
    response: 'Nous vous remercions de bien vouloir vous référer au calendrier de réservation',
    goToReserve: 'Accès au calendrier',
    dialing: 'Numérotation',
    dialingHint: 'Une fois connecté, vous accèderez à un nouvel onglet',
    handupPhoneHint: 'Votre appel n\'est pas encore connecté,',
    handupPhoneHint2: 'Veuillez confirmer si vous souhaitez raccrocher ?',
    otherFunctions: 'autres fonctions',
    returnToFirstPanorama: 'Retour au premier panorama',
    cookieBannerContent: 'We use cookies to enhance your browsing experience, serve personalized ads or content. By forwarding of viewing the website, you consent to our use of cookies. Please check',
    cookieBannerContentLinkAfter: 'for detail.',
    cookieBannerPolicyLinkText: 'iStaging Privacy Statement',
    cookieBannerButtonText: 'Accept'
  }
}

export default fr
